import * as mt from './mutation-types';
import { WeatherState, WeatherPayload } from './types'

export default {
  // TEMPERATURE
  [mt.CLEANUP_TEMPERATURE](state: WeatherState) {
    state.currentTemperatureAverageContext = new Map();
    state.currentTemperatureAverageStatus = new Map();

    state.historicalTemperatureAverageContext = new Map();
    state.historicalTemperatureAverageStatus = new Map(); 

    state.periodTemperatureAverageContext = new Map();
    state.periodTemperatureAverageStatus = new Map(); 
  },
  
  [mt.FETCHING_CURRENT_TEMPERATURE_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.currentTemperatureAverageStatus = state.currentTemperatureAverageStatus.set(cacheKey, 'fetching');
    state.currentTemperatureAverageStatus = new Map(state.currentTemperatureAverageStatus);
  },
  [mt.FETCH_CURRENT_TEMPERATURE_AVERAGE](state: WeatherState, { cacheKey, weatherDataList }: WeatherPayload) {
    state.currentTemperatureAverageContext = state.currentTemperatureAverageContext.set(cacheKey, weatherDataList);
    state.currentTemperatureAverageContext = new Map(state.currentTemperatureAverageContext);
    state.currentTemperatureAverageStatus = state.currentTemperatureAverageStatus.set(cacheKey, 'fetch');
    state.currentTemperatureAverageStatus = new Map(state.currentTemperatureAverageStatus);
  },
  [mt.FETCH_CURRENT_TEMPERATURE_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.currentTemperatureAverageContext = state.currentTemperatureAverageContext.set(cacheKey, []);
    state.currentTemperatureAverageContext = new Map(state.currentTemperatureAverageContext);
    state.currentTemperatureAverageStatus = state.currentTemperatureAverageStatus.set(cacheKey, 'error');
    state.currentTemperatureAverageStatus = new Map(state.currentTemperatureAverageStatus);
  },

  [mt.FETCHING_PERIOD_TEMPERATURE_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.periodTemperatureAverageStatus = state.periodTemperatureAverageStatus.set(cacheKey, 'fetching');
    state.periodTemperatureAverageStatus = new Map(state.periodTemperatureAverageStatus);
  },
  [mt.FETCH_PERIOD_TEMPERATURE_AVERAGE](state: WeatherState,  { cacheKey, weatherDataList }: WeatherPayload) {
    state.periodTemperatureAverageContext = state.periodTemperatureAverageContext.set(cacheKey, weatherDataList);
    state.periodTemperatureAverageContext = new Map(state.periodTemperatureAverageContext);
    state.periodTemperatureAverageStatus = state.periodTemperatureAverageStatus.set(cacheKey, 'fetch');
    state.periodTemperatureAverageStatus = new Map(state.periodTemperatureAverageStatus);
  },
  [mt.FETCH_PERIOD_TEMPERATURE_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.periodTemperatureAverageContext = state.periodTemperatureAverageContext.set(cacheKey, []);
    state.periodTemperatureAverageContext = new Map(state.periodTemperatureAverageContext);
    state.periodTemperatureAverageStatus = state.periodTemperatureAverageStatus.set(cacheKey, 'error');
    state.periodTemperatureAverageStatus = new Map(state.periodTemperatureAverageStatus);
  },
  
  [mt.FETCHING_HISTORICAL_TEMPERATURE_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.historicalTemperatureAverageStatus = state.historicalTemperatureAverageStatus.set(cacheKey, 'fetching');
    state.historicalTemperatureAverageStatus = new Map(state.historicalTemperatureAverageStatus);
  },
  [mt.FETCH_HISTORICAL_TEMPERATURE_AVERAGE](state: WeatherState,  { cacheKey, weatherDataList }: WeatherPayload) {
    state.historicalTemperatureAverageContext = state.historicalTemperatureAverageContext.set(cacheKey, weatherDataList);
    state.historicalTemperatureAverageContext = new Map(state.historicalTemperatureAverageContext);
    state.historicalTemperatureAverageStatus = state.historicalTemperatureAverageStatus.set(cacheKey, 'fetch');
    state.historicalTemperatureAverageStatus = new Map(state.historicalTemperatureAverageStatus);
  },
  [mt.FETCH_HISTORICAL_TEMPERATURE_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.historicalTemperatureAverageContext = state.historicalTemperatureAverageContext.set(cacheKey, []);
    state.historicalTemperatureAverageContext = new Map(state.historicalTemperatureAverageContext);
    state.historicalTemperatureAverageStatus = state.historicalTemperatureAverageStatus.set(cacheKey, 'error');
    state.historicalTemperatureAverageStatus = new Map(state.historicalTemperatureAverageStatus);
  },

  // SPI-4
  [mt.CLEANUP_SPI4](state: WeatherState) {
    state.currentSPI4AverageContext = new Map();
    state.currentSPI4AverageStatus = new Map();

    state.historicalSPI4AverageContext = new Map();
    state.historicalSPI4AverageStatus = new Map(); 

    state.periodSPI4AverageContext = new Map();
    state.periodSPI4AverageStatus = new Map(); 
  },

  [mt.FETCHING_CURRENT_SPI4_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.currentSPI4AverageStatus = state.currentSPI4AverageStatus.set(cacheKey, 'fetching');
    state.currentSPI4AverageStatus = new Map(state.currentSPI4AverageStatus);
  },
  [mt.FETCH_CURRENT_SPI4_AVERAGE](state: WeatherState,  { cacheKey, weatherDataList }: WeatherPayload) {
    state.currentSPI4AverageContext = state.currentSPI4AverageContext.set(cacheKey, weatherDataList);
    state.currentSPI4AverageContext = new Map(state.currentSPI4AverageContext);
    state.currentSPI4AverageStatus = state.currentSPI4AverageStatus.set(cacheKey, 'fetch');
    state.currentSPI4AverageStatus = new Map(state.currentSPI4AverageStatus);
  },
  [mt.FETCH_CURRENT_SPI4_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.currentSPI4AverageContext = state.currentSPI4AverageContext.set(cacheKey, []);
    state.currentSPI4AverageContext = new Map(state.currentSPI4AverageContext);
    state.currentSPI4AverageStatus = state.currentSPI4AverageStatus.set(cacheKey, 'error');
    state.currentSPI4AverageStatus = new Map(state.currentSPI4AverageStatus);
  },

  [mt.FETCHING_PERIOD_SPI4_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.periodSPI4AverageStatus = state.periodSPI4AverageStatus.set(cacheKey, 'fetching');
    state.periodSPI4AverageStatus = new Map(state.periodSPI4AverageStatus);
  },
  [mt.FETCH_PERIOD_SPI4_AVERAGE](state: WeatherState,  { cacheKey, weatherDataList }: WeatherPayload) {
    state.periodSPI4AverageContext = state.periodSPI4AverageContext.set(cacheKey, weatherDataList);
    state.periodSPI4AverageContext = new Map(state.periodSPI4AverageContext);
    state.periodSPI4AverageStatus = state.periodSPI4AverageStatus.set(cacheKey, 'fetch');
    state.periodSPI4AverageStatus = new Map(state.periodSPI4AverageStatus);
  },
  [mt.FETCH_PERIOD_SPI4_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.periodSPI4AverageContext = state.periodSPI4AverageContext.set(cacheKey, []);
    state.periodSPI4AverageContext = new Map(state.periodSPI4AverageContext);
    state.periodSPI4AverageStatus = state.periodSPI4AverageStatus.set(cacheKey, 'error');
    state.periodSPI4AverageStatus = new Map(state.periodSPI4AverageStatus);
  },
  
  [mt.FETCHING_HISTORICAL_SPI4_AVERAGE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.historicalSPI4AverageStatus = state.historicalSPI4AverageStatus.set(cacheKey, 'fetching');
    state.historicalSPI4AverageStatus = new Map(state.historicalSPI4AverageStatus);
  },
  [mt.FETCH_HISTORICAL_SPI4_AVERAGE](state: WeatherState,  { cacheKey, weatherDataList }: WeatherPayload) {
    state.historicalSPI4AverageContext = state.historicalSPI4AverageContext.set(cacheKey, weatherDataList);
    state.historicalSPI4AverageContext = new Map(state.historicalSPI4AverageContext);
    state.historicalSPI4AverageStatus = state.historicalSPI4AverageStatus.set(cacheKey, 'fetch');
    state.historicalSPI4AverageStatus = new Map(state.historicalSPI4AverageStatus);
  },
  [mt.FETCH_HISTORICAL_SPI4_FAILURE](state: WeatherState, { cacheKey }: { cacheKey: string }) {
    state.historicalSPI4AverageContext = state.historicalSPI4AverageContext.set(cacheKey, []);
    state.historicalSPI4AverageContext = new Map(state.historicalSPI4AverageContext);
    state.historicalSPI4AverageStatus = state.historicalSPI4AverageStatus.set(cacheKey, 'error');
    state.historicalSPI4AverageStatus = new Map(state.historicalSPI4AverageStatus);
  },  
};
